import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type StepLabelsProps } from '@process-advisor/process-miner/api/methods/settings/changeStepLabels';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const StepLabels = () => {
    const [stepLabels, setStepLabels] = React.useState<StepLabelsProps>({});
    const onChange = _.curry((
        key: keyof StepLabelsProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newStepLabels = { ...stepLabels, [key]: e.target.checked };
        setStepLabels(newStepLabels);
        apiProvider.changeStepLabels(newStepLabels);
        apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setStepLabels(apiProvider.getStepLabels());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setStepLabels(apiProvider.getStepLabels());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    const label = '# ' + apiProvider.getEntityLower() + 's'
    return (
        <Wrapper>
            <Checkbox
                label={label}
                checked={!!stepLabels.tasks}
                handleOnChange={onChange('tasks')} />
            <Checkbox
                label='% total'
                checked={!!stepLabels.total}
                handleOnChange={onChange('total')} />
            <Checkbox
                label='average duration'
                checked={!!stepLabels.avg_duration}
                handleOnChange={onChange('avg_duration')} />
        </Wrapper>
    );
};
